// Shared day/night lighting model driven by a single time-of-day (hours 6..24).
export function sunParams(hours) {
  // daytime window 6..18; angle 0..PI sweeps east->west so shadows move
  const dayT = (hours - 6) / 12; // 0 at 6am, 1 at 6pm
  const angle = Math.PI * Math.min(Math.max(dayT, 0), 1);
  const elev = Math.sin(angle); // 0 at horizon, 1 at noon
  const isDay = hours >= 6 && hours <= 18.5;
  const dayFactor = isDay ? Math.max(0, elev) : 0; // 0 at night
  // directional light position (unit-ish); x flips across the sky
  const dir = [Math.cos(angle) * 12, Math.max(1.5, elev * 16), 8];
  return {
    dir,
    dayFactor,
    isDay,
    night: 1 - dayFactor,
    // color warms near sunrise/sunset
    warm: elev < 0.35 && isDay,
  };
}
